import { JsonLogicOperator } from '@atlassian/jira-polaris-domain-field/src/decoration/constants.tsx';
import jsonLogic from '@atlassian/jira-polaris-lib-json-logic/src/index.tsx';
import type { RulesLogic } from '@atlassian/jira-polaris-domain-field/src/decoration/types.tsx';
import type { RangeType } from './types.tsx';

export const createBetweenLogic = (gte = 0, lte = 0): RulesLogic => {
	return { [JsonLogicOperator.LTE]: [gte, { var: 'value' }, lte] };
};

export const createLessThanLogic = (lte = 0): RulesLogic => {
	return { [JsonLogicOperator.LT]: [{ var: 'value' }, lte] };
};

export const createGreaterThanLogic = (gte = 0): RulesLogic => {
	return { [JsonLogicOperator.GT]: [{ var: 'value' }, gte] };
};

export const createDefaultLogic = (type: RangeType): RulesLogic => {
	switch (type) {
		case 'GT':
			return createGreaterThanLogic();
		case 'LT':
			return createLessThanLogic();
		case 'BT':
			return createBetweenLogic();
		default:
			throw new Error('Invalid range type');
	}
};

export const applyNumberLogic = (logic: RulesLogic, value: number): boolean => {
	return jsonLogic.apply(logic, { value });
};
